import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/_helpers/auth.guard";
import { Role } from "src/_models/user";
import { SportManagementComponent } from "./pages/sport-management/sport-management.component";
import { HomeComponent } from "./components/home/home.component";
import { LogInComponent } from "./components/log-in/log-in.component";
import { DahsboardComponent } from "./pages/dahsboard/dahsboard.component";
import { ColorConfigurationComponent } from "./pages/color-configuration/color-configuration.component";
import {
  BetListComponent,
  ProviderManagementComponent,
  UserAccountComponent,
  UserManagementComponent,
  OperatorsManagementComponent,
  CompetitionManagementComponent,
  EventManagementComponent,
  SettingManagementComponent,
  ArbitrageConfigurationComponent,
  SportArbitrageDecisionsComponent,
  EventArbitrageDecisionsComponent,
  ArbitrageDecisionsDetailComponent,
  ArbitrageDecisionsComponent,
  ArbitrageReportComponent,
  EventArbitrageReportComponent,
  PlacedBetsComponent,
  CreateOperatorsComponent,
  CreateUsersComponent,
  FundStatementComponent,
  MarketManagementComponent,
  MarketRiskComponent,
  PartnersManagementComponent,
  EventMappingComponent,
  UserHistoryComponent,
  PLStatmentComponent,
  PLSportStatmentComponent,
  PLCompetitionStatmentComponent,
  PLEventStatmentComponent,
  PLMarketStatmentComponent,
  GameReportComponent,
  GrProviderLevelComponent,
  GmRepSportsLevelComponent,
  GmRepComptsLevelComponent,
  GmRepEventsLevelComponent,
  GmRepMarketLevelComponent,
  GmRepUserLevelComponent,
  AdminManagementComponent,
  UserAuditComponent,
  UserPLComponent,
  LeakLedgerComponent,
  MtsReportingSummaryComponent,
  MtsDayDetailComponent,
  MtsReportGeneratorComponent,
  MtsAccountsComponent,
  MtsRejectionsComponent,
  MtsAccountDetailComponent,
  HoldReportComponent,
  MarketSettlementsComponent,
  SapMetricsComponent,
  CatalogueManagementComponent,
  TestCasesComponent,
  TestCasesResultComponent,
  MappingComponent,
  CommissionEventMarketsComponent,
  CommissionMarketMarketLevelComponent,
  EditUserComponent,
  BetsSettlementsComponent,
  EventsSettlementsComponent,
  AlertBetsComponent,
  GameAnalysisComponent,
} from "./pages/index";
import { PlaceHolderComponent } from "./components/place-holder/place-holder.component";
import { EventRiskComponent } from "./pages/market-risk/event-risk/event-risk.component";
import { CommissionMarketsComponent } from "./pages/commission-markets/commission-markets.component";
import { MarketMappingComponent } from "./pages/market-mapping/market-mapping.component";
import { MarketMappingTableComponent } from "./pages/market-mapping-table/market-mapping-table.component";
import { BetsMonitoringComponent } from "./pages/bets-monitoring/bets-monitoring.component";
import { AddMarketComponent } from "./pages/add-market/add-market.component";
import { OperatorUsersComponent } from "./pages/operator-users/operator-users.component";
import { OperatorProviderManagementComponent } from "./pages/operator-provider-management/operator-provider-management.component";
import { ProviderMarketsComponent } from "./pages/provider-markets/provider-markets.component";
import { EditMarketComponent } from "./pages/edit-market/edit-market.component";
import { PreviewScreenComponent } from "./pages/preview-screen/preview-screen.component";
import { MarketBetsSettlementComponent } from "./pages/market-bets-settlement/market-bets-settlement.component";
import { TommyManualComponent } from "./pages/tommy-manual/tommy-manual.component";
import { OperatorDashboardComponent } from "./pages/operator-dashboard/operator-dashboard.component";
import { SrEventsComponent } from "./pages/sr-events/sr-events.component";
import { SrBetsSettlementComponent } from "./pages/sr-bets-settlement/sr-bets-settlement.component";
import { RiskBetsComponent } from "./pages/risk-bets/risk-bets.component";
import { DbCollectionComponent } from "./pages/db-collection/db-collection.component";
import { PremiumMappingComponent } from "./pages/premium-mapping/premium-mapping.component";
import { GeniePremiumMappingComponent } from "./pages/genie-premium-mapping/genie-premium-mapping.component";
import { OpEventsComponent } from "./op-events/op-events.component";
import { OpMarketsComponent } from "./op-markets/op-markets.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { OpBetsSettleComponent } from "./pages/op-bets-settle/op-bets-settle.component";
import { VirtualMetricsComponent } from "./pages/virtual-metrics/virtual-metrics.component";
import { SrMarketVoidComponent } from "./pages/sr-market-void/sr-market-void.component";
import { B2bOperatorsComponent } from "./pages/b2b-operators/b2b-operators.component";
import { InvoiceManagementComponent } from "./pages/invoice-management/invoice-management.component";
import { InvoicePrMngtComponent } from "./pages/invoice-pr-mngt/invoice-pr-mngt.component";
import { InvoiceReportComponent } from "./pages/invoice-report/invoice-report.component";
import { CatalogueEventsComponent } from "./pages/catalogue-events/catalogue-events.component";
import { CatalogueMarketsComponent } from "./pages/catalogue-markets/catalogue-markets.component";
import { CatalogueRulesComponent } from "./pages/catalogue-rules/catalogue-rules.component";
import { LimitsManagementComponent } from "./pages/limits-management/limits-management.component";
import { CatalogueAutoMapComponent } from "./pages/catalogue-auto-map/catalogue-auto-map.component";
import { CrmEventsComponent } from "./pages/crm-events/crm-events.component";
import { CrmMarketsComponent } from "./pages/crm-markets/crm-markets.component";
import { TwoFactorComponent } from "./components/two-factor/two-factor.component";

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "administration",
        component: SportManagementComponent,
      },
      {
        path: "administration/users",
        component: UserManagementComponent,
      },
      {
        path: "administration/users/:OperatorId",
        component: OperatorUsersComponent,
      },

      {
        path: "administration/operators",
        component: OperatorsManagementComponent,
      },
      {
        path: "administration/partners",
        component: PartnersManagementComponent,
      },

      {
        path: "administration/providers",
        component: ProviderManagementComponent,
      },
      {
        path: "administration/limits",
        component: LimitsManagementComponent,
      },
      {
        path: "administration/catalogue",
        component: CatalogueManagementComponent,
      },
      {
        path: "administration/mapping",
        component: MappingComponent,
      },
      {
        path: "administration/pr-mapping",
        component: PremiumMappingComponent,
      },
      {
        path: "administration/genie-premium-mapping",
        component: GeniePremiumMappingComponent,
      },
      {
        path: "administration/operator-providers",
        component: OperatorProviderManagementComponent,
      },
      {
        path: "administration/operator-providers/:operatorId",
        component: ProviderMarketsComponent,
      },
      {
        path: "administration/market-mapping",
        component: MarketMappingComponent,
      },
      {
        path: "administration/market-map",
        component: MarketMappingTableComponent,
      },
      {
        path: "administration/color-configuration",
        component: ColorConfigurationComponent,
      },
      {
        path: "administration/commission-markets",
        component: CommissionMarketsComponent,
      },
      {
        path: "administration/commission-markets/:providerId/:sportId/:competitionId",
        component: CommissionEventMarketsComponent,
      },
      {
        path: "administration/commission-markets/:providerId/:sportId/:competitionId/:eventId",
        component: CommissionMarketMarketLevelComponent,
      },
      {
        path: "administration/providers/:operator/:provider",
        component: SportManagementComponent,
      },
      {
        path: "administration/providers/:operator/:provider/:sport",
        component: CompetitionManagementComponent,
      },
      {
        path: "administration/providers/:operator/:provider/:sport/:competition",
        component: EventManagementComponent,
      },
      {
        path: "administration/providers/:operator/:provider/:sport/:competition/:eventId/:eventName/add-market",
        component: AddMarketComponent,
      },
      {
        path: "administration/providers/:operator/:provider/:sport/:competition/:eventId/:eventName/edit-market",
        component: EditMarketComponent,
      },
      {
        path: "administration/providers/:operator/:provider/:sport/:competition/:event",
        component: MarketManagementComponent,
      },
      // {
      //   path: "administration/providers/:provider/:sport/:competition/:event/:market",
      //   component: ProviderManagementComponent,
      // },
      {
        path: "administration/competition",
        component: CompetitionManagementComponent,
      },
      {
        path: "administration/event",
        component: EventManagementComponent,
      },
      {
        path: "administration/event-mapping",
        component: EventMappingComponent,
      },
      {
        path: "administration/market",
        component: MarketManagementComponent,
      },
      {
        path: "reports/risk_analysis",
        component: MarketRiskComponent,
      },
      {
        path: "reports/risk_analysis/:providerId/:sportId/:eventId",
        component: EventRiskComponent,
      },
      {
        path: "administration/games",
        component: SportManagementComponent,
      },
      {
        path: "reports/bet_list/:id",
        component: BetListComponent,
      },
      {
        path: "surveillance/bet_monitoring",
        component: BetsMonitoringComponent,
      },
      // {
      //   path: "surveillance/alert_bets",
      //   component: AlertBetsComponent,
      // },
      // {
      //   path: "surveillance/game_analysis",
      //   component: GameAnalysisComponent,
      // },
      {
        path: "surveillance/events",
        component: OpEventsComponent,
      },
      {
        path: "surveillance/markets",
        component: OpMarketsComponent,
      },
      {
        path: "surveillance/voided-markets",
        component: SrMarketVoidComponent,
      },
      {
        path: "surveillance/sr_events",
        component: SrEventsComponent,
      },
      {
        path: "surveillance/sr_bets_settlement",
        component: SrBetsSettlementComponent,
      },
      {
        path: "surveillance/risk_bets",
        component: RiskBetsComponent,
      },
      {
        path: "surveillance/settlements",
        component: OpBetsSettleComponent,
      },
      {
        path: "preview-screen",
        component: PreviewScreenComponent,
      },
      {
        path: "reports/user-audit",
        component: UserAuditComponent,
      },
      // {
      //   path: "reports/test-cases",
      //   component: TestCasesComponent,
      // },
      {
        path: "reports/test-cases-results",
        component: TestCasesResultComponent,
      },
      {
        path: "reports/user_account",
        component: UserAccountComponent,
      },
      {
        path: "reports/game_report",
        component: GameReportComponent,
      },
      {
        path: "reports/game_report/:providerId",
        component: GrProviderLevelComponent,
      },
      {
        path: "reports/arbitrage-report",
        component: ArbitrageReportComponent,
      },
      {
        path: "reports/event-arbitrage-report",
        component: EventArbitrageReportComponent,
      },
      {
        path: "reports/placed-bets",
        component: PlacedBetsComponent,
      },
      {
        path: "reports/game_report/:providerId/:sportId",
        component: GmRepSportsLevelComponent,
      },
      {
        path: "reports/game_report/:providerId/:sportId/:competitionId",
        component: GmRepComptsLevelComponent,
      },
      {
        path: "reports/game_report/:providerId/:sportId/:competitionId/:eventId",
        component: GmRepEventsLevelComponent,
      },
      {
        path: "reports/game_report/:providerId/:sportId/:competitionId/:eventId/:marketId",
        component: GmRepUserLevelComponent,
      },
      {
        path: "reports/game_report/:providerId/:sportId/:competitionId/:eventId/:marketId/:userId",
        component: GmRepMarketLevelComponent,
      },
      // {
      //   path: "reports/game_report/:providerId/:sportId/:competitionId/:eventId/:marketId?:userId",
      //   component: GameReportComponent,
      // },
      {
        path: "reports/user_history",
        component: UserHistoryComponent,
      },
      {
        path: "reports/dbcollection",
        component: DbCollectionComponent,
      },
      {
        path: "reports/user-pl",
        component: UserPLComponent,
      },
      {
        path: "sap-metrics",
        component: SapMetricsComponent,
      },
      {
        path: "virtual-metrics",
        component: VirtualMetricsComponent,
      },
      {
        path: "settlements-events",
        component: EventsSettlementsComponent,
      },
      {
        path: "settlemts-markets",
        component: MarketSettlementsComponent,
      },
      {
        path: "bet-settlement",
        component: BetsSettlementsComponent,
      },
      {
        path: "market-bet-settlement",
        component: MarketBetsSettlementComponent,
      },
      {
        path: "administration/tommy-manual",
        component: TommyManualComponent,
      },
      {
        path: "reports/leak-ledger",
        component: LeakLedgerComponent,
      },
      {
        path: "mts/reporting-summary",
        component: MtsReportingSummaryComponent,
      },
      {
        path: "mts/day/:day",
        component: MtsDayDetailComponent,
      },
      {
        path: "mts/profitability-report",
        component: MtsDayDetailComponent,
      },
      {
        path: "mts/report-generator",
        component: MtsReportGeneratorComponent,
      },
      {
        path: "mts/rejections",
        component: MtsRejectionsComponent,
      },
      {
        path: "mts/accounts",
        component: MtsAccountsComponent,
      },
      {
        path: "mts/account/:accountId",
        component: MtsAccountDetailComponent,
      },
      {
        path: "reports/sr-fallback-holds",
        component: HoldReportComponent,
      },
      {
        path: "reports/pl-statment",
        component: PLStatmentComponent,
      },

      {
        path: "reports/pl-statment/:sportId",
        component: PLSportStatmentComponent,
      },
      {
        path: "reports/pl-statment/:sportId/:competitionId",
        component: PLCompetitionStatmentComponent,
      },
      {
        path: "reports/pl-statment/:sportId/:competitionId/:eventId",
        component: PLEventStatmentComponent,
      },
      {
        path: "reports/pl-statment/:sportId/:competitionId/:eventId/:marketId",
        component: PLMarketStatmentComponent,
      },
      {
        path: "reports/admin-statment",
        component: AdminManagementComponent,
      },
      {
        path: "create-operator",
        component: CreateOperatorsComponent,
      },
      {
        path: "create-user",
        component: CreateUsersComponent,
      },
      {
        path: "edit-user",
        component: EditUserComponent,
      },
      {
        path: "fund-statement/:operatorId/:partnerId",
        component: FundStatementComponent,
      },
      {
        path: "user/portal",
        component: UserManagementComponent,
      },
      {
        path: "user/operator",
        component: B2bOperatorsComponent,
      },
      {
        path: "users/:OperatorId",
        component: OperatorUsersComponent,
      },
      {
        path: "invoice/management",
        component: InvoiceManagementComponent,
      },
      {
        path: "invoice/management/iframe",
        component: InvoicePrMngtComponent,
      },
      {
        path: "invoice/report",
        component: InvoiceReportComponent,
      },
      {
        path: "catalog/catalog-events",
        component: CatalogueEventsComponent,
      },
      {
        path: "catalog/catalog-rules",
        component: CatalogueRulesComponent,
      },
      {
        path: "catalog/catalog-markets",
        component: CatalogueMarketsComponent,
      },
      {
        path: "catalog/catalog-auto-map",
        component: CatalogueAutoMapComponent,
      },
      {
        path: "catalog/catalog-mapping-events",
        component: CrmEventsComponent,
      },
      {
        path: "catalog/catalog-mapping-markets",
        component: CrmMarketsComponent,
      },
      // {
      //   path:"add-market/:eventId/:eventName",
      //   component: AddMarketComponent
      // },
      { path: "setting-management", component: SettingManagementComponent },
      {
        path: "administration/arbitrage-configuration",
        component: ArbitrageConfigurationComponent,
      },
      {
        path: "administration/sport-arbitrage-decisions",
        component: SportArbitrageDecisionsComponent,
      },
      {
        path: "administration/event-arbitrage-decisions",
        component: EventArbitrageDecisionsComponent,
      },
      {
        path: "administration/arbitrage-decisions-detail",
        component: ArbitrageDecisionsDetailComponent,
      },
      {
        path: "administration/arbitrage-decisions",
        component: ArbitrageDecisionsComponent,
      },
      { path: "setting", component: PlaceHolderComponent },
      { path: "reports/games", component: PlaceHolderComponent },
      { path: "reports/users", component: PlaceHolderComponent },
      { path: "reports/summary", component: PlaceHolderComponent },
      { path: "reports/products", component: PlaceHolderComponent },
      { path: "dashboard", component: DashboardComponent },
      { path: "operator-dashboard", component: OperatorDashboardComponent },
    ],
  },
  { path: "login", component: LogInComponent },
  { path: "login/two-factor", component: TwoFactorComponent },

  // otherwise redirect to home
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
